var _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 700 700",
    width: 700,
    height: 700,
    id: "svg10",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ea1921",
    strokeOpacity: 1,
    strokeWidth: 0.3,
    id: "g2",
    transform: "translate(-150.83336,-136.35336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 482,672 c 0,-145 0,-290 0,-435 0.86,-8.7 1.15,-26.26 -9.25,-13.25 -16.83,17.2 -33.68,33.36 -50.5,49.5 -9.44,6.46 -3.68,19.15 -5.25,28.75 0,22.33 0,44.67 0,67 0.74,10.58 2.27,24.86 -13,20 -27.79,0.42 -54.33,8.7 -76.92,24.08 -9.89,8.01 -6.03,-13.87 -4.06,-19.06 8.05,-31.8 36.42,-53.67 52.98,-81.02 -49.48,22.27 -114.11,53.64 -115,117 3.81,66.98 -16.17,145.98 36.08,195.92 45.24,54.23 119.16,48.3 184.92,47.08 M 416,455 c 2.33,50.17 0.33,101.42 1,152 -44.45,5.38 -88.91,-30.07 -88.78,-75.22 -0.14,-44.99 44.1,-79.8 87.78,-76.78 z",
    id: "path2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "None",
    fillOpacity: 0,
    stroke: "#ea1921",
    strokeOpacity: 1,
    strokeWidth: 0.3,
    id: "g3",
    transform: "translate(-150.83336,-136.35336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 612,625 c 38.73,-13.08 79.53,-29.61 104.7,-65.3 31.98,-40.35 22.79,-96.24 22.29,-145.69 C 732.63,372.95 706.85,334.36 670.23,312.77 626.09,284.94 570.34,296.33 519,294 c 0.67,159.92 -1.33,320.5 1,480 21.68,-23.65 45.5,-47.48 64,-73 0,-34.33 0,-68.67 0,-103 2.55,-8.58 -5.93,-27.04 6,-28 27.63,-0.87 52.91,-12.25 76,-26 -2.68,33.91 -38.6,52.91 -54,81 M 584,505 c 0,-38.67 0,-77.33 0,-116 2.47,-9.85 -7.16,-32.6 10,-29 53.68,-4.62 98.31,59.78 68.75,106.75 -15.48,27.12 -47.5,40.51 -78.75,38.25 z",
    id: "path3"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ea1921",
    fillOpacity: 1,
    stroke: "None",
    id: "g7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 331.16664,535.64665 c 0,-145 0,-290 0,-435 0.86,-8.700004 1.15,-26.260004 -9.25,-13.250004 -16.83,17.200004 -33.68,33.360004 -50.5,49.500004 -9.44,6.46 -3.68,19.15 -5.25,28.75 0,22.33 0,44.67 0,67 0.74,10.58 2.27,24.86 -13,20 -27.79,0.42 -54.33,8.7 -76.92,24.08 -9.89,8.01 -6.03,-13.87 -4.06,-19.06 8.05,-31.8 36.42,-53.67 52.98,-81.02 -49.48,22.27 -114.11,53.64 -115,117 3.81,66.98 -16.170001,145.98 36.08,195.92 45.24,54.23 119.16,48.3 184.92,47.08 m -66,-218 c 2.33,50.17 0.33,101.42 1,152 -44.45,5.38 -88.91,-30.07 -88.78,-75.22 -0.14,-44.99 44.1,-79.8 87.78,-76.78 z",
    id: "path7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ea1921",
    fillOpacity: 1,
    stroke: "None",
    id: "g8",
    transform: "translate(-150.83336,-136.35336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 612,625 c 38.73,-13.08 79.53,-29.61 104.7,-65.3 31.98,-40.35 22.79,-96.24 22.29,-145.69 C 732.63,372.95 706.85,334.36 670.23,312.77 626.09,284.94 570.34,296.33 519,294 c 0.67,159.92 -1.33,320.5 1,480 21.68,-23.65 45.5,-47.48 64,-73 0,-34.33 0,-68.67 0,-103 2.55,-8.58 -5.93,-27.04 6,-28 27.63,-0.87 52.91,-12.25 76,-26 -2.68,33.91 -38.6,52.91 -54,81 M 584,505 c 0,-38.67 0,-77.33 0,-116 2.47,-9.85 -7.16,-32.6 10,-29 53.68,-4.62 98.31,59.78 68.75,106.75 -15.48,27.12 -47.5,40.51 -78.75,38.25 z",
    id: "path8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f0dd7fd7734c302d5fdc66bc53871919.svg";
export { ForwardRef as ReactComponent };